import React from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import about from '../../media/about.jpeg';
import founders from '../../media/founders.jpeg';
import './About.css';

const About = () => {
    return (
        <div>
            <Header></Header>
            <section className="pb-5">
                <div id="about-us" className="about">
                    <div>
                        <div className="mb-5">
                            <div className="mx-auto mb-3 mb-lg-0">
                                <img className="img-fluid" src={about} alt="" />
                            </div>
                            <div className="d-flex justify-content-center" data-aos="fade-up">
                                <div className="row highlight d-flex text-center shadow-lg bg-dark col-12 col-lg-9 rounded-3 p-3 px-lg-5 py-lg-4 text-white text-start">
                                    <p className="text-start">
                                        You know our name, and steaks are our game.
                                        Without a doubt, there is an ancient connection between man, fire and food. The history of grilling stretches back to caveman days, when a brilliant ancestor of ours discovered that holding meat directly over an open flame for an extended period of time “cooked” the meat.        </p>
                                    <p className=" text-start">
                                        Produce and ingredients are one thing, but only half the story at 500 Degrees, technique, temperature and traditional cooking methods are equally instrumental to the creativity of our kitchen.
                                    </p>
                                    <p className=" text-start">
                                        Our steaks and ribs are cooked over open flamed char grill, one of the hardest ways to cook, but we believe gets the tastiest results.
                                    </p>
                                    <p className=" text-start">
                                        Food at 500 Degrees revolves around the concept of locally sourced produce. Keeping our distribution footprint down low and down under. This enables us to get food to your plate faster and fresher.
                                    </p>

                                </div>
                            </div>

                        </div>
                        <div className="my-5">
                            <div className="col-11 col-lg-9 mx-auto mb-3">
                                <div className="my-5 pt-lg-5 text-start">
                                    <h3 className="fw-bold"> Nadim & Ari (Owners & Chefs)</h3>
                                    <p>
                                        After working over 10 years as Chefs, we opened 500 Degrees in 2016.

                                        Our passion is to provide fresh-from-the-farm, top quality meat to everyday families just like ours and we have a proud reputation of doing just that.
                                        The idea that the meat we put on the plate for our customers and their families has a higher amount of bodybuilding, health promoting nutrients makes our job worthwhile. It’s not just a job, it serves a purpose. Even more so for feeding children, who tend to be picky eaters. Each bite of meat counts for more nutrition when you feed them good quality beef.

                                        At 500 Degrees our meals are inspired by the South African tradition of Braai. We cook your meats over an open fire and encourage you to enjoy the experience with family and friends, just like it should be.
                                    </p>
                                </div>
                                <img className="rounded-3 img-fluid" src={founders} alt="" />
                            </div>

                        </div>
                    </div>


                </div>
            </section>
            <Footer></Footer>
        </div>
    );
};

export default About;